<template>
    <div class="edit-vignette-form-container page-content">
        <!--    notes    -->
        <div class="tab-header-container">
            <h2 class="form-label">{{getTitle}}</h2>
            <LiteButton @click.native="close"
                        style="font-size: 35px; float: right;"
                        class="edit-button"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <div class="form-container-vignette">
            <label class="vignette-datepicker-label">Дата на изтичане на валидност</label>
            <date-picker v-model="expiryDate"
                         type="date"
                         class="date-input"
                         :format="'DD-MM-YYYY'"
                         :lang="{formatLocale: getFormatLocale()}"
                         placeholder="Изберете дата"/>
            <ErrorInput class="error" v-if="shouldShowError('expiryDate')" :text="errors['expiryDate']"/>

            <CountryDropdown :id="'countryDropdown'"
                             :name="'countryDropdown'"
                             :label="'Държава'"
                             style="margin-top: 40px; margin-bottom: 10px;"
                             :defaultSelected="vignette && vignette.id && vignette.country ? vignette.country : null"
                             @selection-change="setCountry"/>
            <ErrorInput class="error" v-if="shouldShowError('country')" :text="errors['country']"/>
        </div>

        <Button class="save-button"
                @click.native="saveForm"
                :color="'green'"
                :text="'Запази'"
                :icon="'fa fa-save'"></Button>

        <Button class="save-button"
                style="margin-top: 60px;"
                v-if="this.currentVignette.id"
                @click.native="showDeleteConfirm = true"
                :color="'red'"
                :text="'Изтрий'"
                :icon="'fa fa-trash-alt'"></Button>

        <div id="confirmDeleteVignette" class="delete-vignette-confirm" v-if="showDeleteConfirm">
            <p>Сигурне ли сте?</p>
            <Button class="delete-vignette-button-confirm" @click.native="deleteVignette" :id="'yes'"
                    :text="'Да'"></Button>
            <Button class="delete-vignette-button-confirm" @click.native="showDeleteConfirm = false" :id="'no'"
                    :text="'Не'"></Button>
        </div>
    </div>
</template>

<script>
    import Button from "@/shared/components/button/Button";
    import LiteButton from "@/shared/components/button/LiteButton";
    import {cloneDeep} from 'lodash';
    import carService from "@/services/car.service";
    import DatePicker from 'vue2-datepicker';
    import dateService from "@/services/date.service";
    import ErrorInput from "@/shared/components/form/ErrorInput";

    export default {
        name: "CarVignettesEditForm",
        components: {ErrorInput, LiteButton, Button, DatePicker},
        props: {
            vignette: Object
        },
        created() {
            this.expiryDate = this.vignette && this.vignette.id && this.vignette.expiryDate ? new Date(this.vignette.expiryDate) : null;
        },
        data() {
            return {
                currentVignette: cloneDeep(this.vignette),
                showDeleteConfirm: false,
                expiryDate: null,
                errors: {}
            }
        },
        methods: {
            setCountry(value) {
                if (value.currentValueId) {
                    this.currentVignette.country = {iso: value.currentValueId};
                    this.errors['country'] = null;
                } else {
                    this.currentVignette.country = null;
                }
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            },
            saveForm() {
                carService.addOrEditVignette(this.currentVignette)
                    .then(({data}) => {
                        this.$store.commit('setCarVignettes', data);
                        this.$emit('close-clicked', {});
                    })
                    .catch((errors) => this.errors = errors.response.data.errors);
            },
            getFormatLocale() {
                return dateService.getFormatLocale();
            },
            deleteVignette() {
                carService.deleteVignette(this.currentVignette.id)
                    .then(({data}) => {
                        this.$store.commit('setCarVignettes', data);
                        this.$emit('close-clicked', {});
                    })
                    .catch(() => this.$emit('close-clicked', {}));
            },
            close() {
                this.$emit('close-clicked', {});
            }
        },
        computed: {
            getTitle() {
                return this.currentVignette.id ? 'Редактиране на винетка' : 'Добавяне на винетка';
            }
        },
        watch: {
            expiryDate: {
                handler(newVal) {
                    if (newVal) {
                        this.currentVignette.expiryDate = dateService.formatDateISO(newVal);
                        this.errors['expiryDate'] = null;
                    } else {
                        this.currentVignette.expiryDate = null;
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .edit-vignette-form-container {
        width: 900px;
        height: fit-content;
        margin: 50px auto;
        padding: 20px;
        z-index: 120;
        background-color: #ffffff;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .save-button {
        width: 300px;
        height: 60px;
        font-size: 26px;
        margin: 45px;
    }

    .delete-vignette-confirm p {
        text-align: center;
    }

    .date-input {
        width: 100%;
        float: left;
        margin-bottom: 10px;
    }

    .delete-vignette-button-confirm {
        width: 80px;
        height: 40px;
        float: left;
        margin: 10px;
        font-size: 20px;
    }

    .delete-vignette-confirm {
        margin: auto;
        height: 80px;
        width: 200px;
        z-index: 20;
        -webkit-box-shadow: 0 0px 5px 1px var(--shadow-color);
        -moz-box-shadow: 0 0px 5px 1px var(--shadow-color);
        box-shadow: 0 0px 5px 1px var(--shadow-color);
        background-color: #ffffff;
        padding: 15px;
        font-size: 24px;
        color: var(--grey);
    }

    .form-container-vignette {
        text-align: left;
        margin: 40px 50px;
    }

    .vignette-datepicker-label {
        float: left;
        height: 30px;
        width: 100%;
        text-align: left;
        margin-left: 5px;
        font-size: 20px;
        color: var(--dark-grey);
    }
</style>